import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
@Component({
  selector: 'swisslife-renonce-profil',
  templateUrl: './swisslife-renonce-profil.component.html',
  styleUrls: ['./swisslife-renonce-profil.component.scss'],
  standalone: false,
})
export class SwisslifeRenonceProfilComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.subscriptionFacade.setStepName('swisslifeRenonceProfil');
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
